import { render, staticRenderFns } from "./InputAnexos.vue?vue&type=template&id=5e1f1912"
import script from "./InputAnexos.vue?vue&type=script&lang=js"
export * from "./InputAnexos.vue?vue&type=script&lang=js"
import style0 from "./InputAnexos.vue?vue&type=style&index=0&id=5e1f1912&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports